<template>
      <div class="comunicazioni-container">
        <button @click="showModal = true" class="create-user-button staff-button-positive">Aggiungi Comunicazione 3 <span class="material-icons">add_circle_outline</span></button>
        

        <div v-if="showModal" class="modal">
          <div class="modal-content">
            <span class="close" @click="showModal = false">&times;</span>
            <form @submit.prevent="addComunicazione">
              <label for="data">Data:</label>
              <input type="date" id="data" v-model="newComunicazione.data">

              <label for="tipo">Tipo:</label>
              <select id="tipo" v-model="newComunicazione.tipo">
                <option value="telefonata">Telefonata</option>
                <option value="whatsapp">Whatsapp</option>
                <option value="email">E-mail</option>
                <option value="live">Dal vivo</option>
                <option value="altro">Altro</option>

              </select>

              <label for="sede">Contattata da:</label>
              <select id="sede" v-model="newComunicazione.sede">
                <option value="sede">Sede</option>
                <option value="studio">Studio</option>
                <option value="trainer">Trainer</option>
              </select>

              <label for="note">Note:</label>
              <textarea id="note" v-model="newComunicazione.note"></textarea>

              <button class="staff-button-positive" type="submit">Salva Comunicazione</button>
            </form>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th></th> <!-- Colonna per le azioni come cancellare -->
              <th>Data</th>
              <th>Tipo</th>
              <th>Da</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="com in comunicazioni" :key="com.id">
      <td>
                        <div class="buttons-container">
                          <button @click="confirmDelete(com.id)" title="Elimina comunicazione">
            <span class="material-icons">delete</span>
          </button>
                    </div>
          
        </td>

        <td>{{ formatDate(com.data) }}</td>
              <td>{{ com.tipo }}</td>
              <td>{{ com.sede }}</td>
              <td class="note-cell">{{ com.note }}</td>
            </tr>
          </tbody>
        </table>
      </div>
</template>


<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getFirestore, collection, addDoc, query, onSnapshot, deleteDoc, doc, orderBy } from 'firebase/firestore';
export default {
  name: "ComunicazioniComponent",
  setup() {
    const showModal = ref(false);
    const comunicazioni = ref([]);
    const newComunicazione = ref({
      data: '',
      tipo: '',
      sede: '',
      note: ''
    });
    const userId = ref(null);
    const route = useRoute();
    const db = getFirestore();

    onMounted(async () => {
      userId.value = route.params.userId;
      fetchComunicazioni();
    });

    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };

    const fetchComunicazioni = () => {
      const comQuery = query(collection(db, "comunicazioni"), orderBy("data", "desc"));
      onSnapshot(comQuery, (querySnapshot) => {
        comunicazioni.value = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      });
    };

    const deleteComunicazione = async (comId) => {
      try {
        await deleteDoc(doc(db, "comunicazioni", comId));
        alert("Comunicazione cancellata correttamente!");
      } catch (error) {
        console.error("Errore nella cancellazione della comunicazione:", error);
        alert("Errore nella cancellazione della comunicazione.");
      }
    };

    const confirmDelete = (comId) => {
      if (confirm("Sei sicuro di voler cancellare?")) {
        deleteComunicazione(comId);
      }
    };

    const addComunicazione = async () => {
      if (!newComunicazione.value.data || !newComunicazione.value.tipo || !newComunicazione.value.sede) {
        alert("Per favore, completa tutti i campi richiesti.");
        return;
      }
      try {
        await addDoc(collection(db, "comunicazioni"), {
          uid: userId.value,
          ...newComunicazione.value
        });
        newComunicazione.value = { data: '', tipo: '', sede: '', note: '' };
        showModal.value = false;
      } catch (error) {
        console.error("Errore nel salvataggio della comunicazione:", error);
        alert("Errore nel salvataggio della comunicazione.");
      }
    };

    return {
      showModal,
      comunicazioni,
      newComunicazione,
      addComunicazione,
      userId,
      deleteComunicazione,
      formatDate,
      confirmDelete
    };
  }
};
</script>





<style scoped>

.note-cell {
  white-space: pre-wrap; /* Mantiene gli spazi e gli a capo come inseriti */
}

#data {
  margin-bottom: 10px; /* Margine aggiunto */
}

textarea#note {
  white-space: pre-wrap; /* Mantiene la formattazione con spazi e a capo */
}

.material-icons{
  margin-left: 5px;
}
table {
  width: 99%;
  padding: 10px;
}
th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th:nth-child(2), th:nth-child(3) { /* Data, Tipo, Sede */
  width: 10%;
}
th:nth-child(4) { /* Note */
  width: 20%;
}

th:nth-child(1) { /* Data, Tipo, Sede */
  width: 4%;
}

tbody tr:nth-child(odd) {
  background-color: #f5f5f5; /* Grigio chiaro per le righe dispari */
}

tbody tr:nth-child(even) {
  background-color: #e9e9e9; /* Grigio scuro per le righe pari */
}
</style>
